exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.source-dropdown button {\n  width: 140px;\n  float: left;\n}\n", "", {"version":3,"sources":["D:/a/1/RTPS-CopayePA-Portal/src/views/BrandLimitList.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;CACb","file":"BrandLimitList.vue","sourcesContent":["\n.source-dropdown button {\n  width: 140px;\n  float: left;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38a3a0ac","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/BrandLimitList.vue
// module id = ugql
// module chunks = 1